import { MailDomain } from '@@types/Api/Tenant';
import { Tenant, TenantDomain } from '@@types/Tenant';

import { ALL_API_SIZE, URLS } from '~/constants';
import Api2 from '~/stores/providers/Api2';
import { getContents, isSuccessful } from '~/utils/apiUtil';

class TenantApi {
  constructor(private api: Api2) {}

  fetchCurrentTenant = (): Promise<Tenant> => {
    return this.api.contentsRequester.get(URLS.WAS_API);
  };

  fetchTenantDomains = (): Promise<TenantDomain[]> => {
    return this.api.contentsRequester.get(`${URLS.WAS_API}/domains`, {
      params: { size: ALL_API_SIZE },
    });
  };

  checkOrgUrl = (orgUrl: string): Promise<Tenant> => {
    return this.api.ignoreErrorRequester.get(`${URLS.WAS_API}/tenants/${orgUrl}`).then((result) => {
      return isSuccessful(result) ? getContents(result) : Promise.reject(result.data);
    });
  };

  fetchMailDomains = (): Promise<MailDomain[]> => {
    return this.api.contentsRequester.get(`${URLS.WAS_API}/mail-domains`, {
      params: { size: ALL_API_SIZE },
    });
  };
}

export default TenantApi;
